<div class="container-fluid" hidden="true">
    <div id="orderPrint">
        <div class="wrapper" *ngIf="!masterSerial && this.orderserves.length>0">
            <div *ngIf="this.selectedOrder.orderPrintFlag !=1">
                <table class="full-width">
                    <tbody>
                        <tr>
                            <td class="groupHeaderLabelCell_ar">
                                <strong style="text-decoration: underline;">إسم المريض</strong>
                            </td>
                            <td class="groupHeaderDataCell_ar">{{orderserves[0]['patientFullnameAr']}}</td>
                            <td class="groupHeaderLabelCell_ar">
                                <strong style="text-decoration: underline;">العمر : </strong>
                            </td>
                            <td class="groupHeaderDataCell_ar">{{orderserves[0]['patientAge']}}</td>
                        </tr>
                        <!---------------------------------------------------------------------------------->
                        <tr>
                            <td class="groupHeaderLabelCell_ar">
                                <strong style="text-decoration: underline;">الرقم الطبى :</strong>
                            </td>
                            <td class="groupHeaderDataCell_ar">{{orderserves[0]['patCode']}}</td>
                            <td class="groupHeaderLabelCell_ar">
                                <strong style="text-decoration: underline;">الطبيب :</strong>
                            </td>
                            <td class="groupHeaderDataCell_ar">{{orderserves[0]['doctorNameAr']}}</td>
                        </tr>
                        <!---------------------------------------------------------------------------------->
                        <tr>
                            <td class="groupHeaderLabelCell_ar">
                                <strong style="text-decoration: underline;">رقم الطلب :</strong>
                            </td>
                            <td class="groupHeaderDataCell_ar">{{orderserves[0]['orderMasterSerial']}}</td>

                            <td class="groupHeaderLabelCell_ar">
                                <strong style="text-decoration: underline;">تاريخ الطلب :</strong>
                            </td>
                            <td class="groupHeaderDataCell_ar">{{orderserves[0]['orderMasterDate'] | date:'dd/MM/yyyy'}}
                            </td>
                        </tr>

                        <!---------------------------------------------------------------------------------->
                        <tr>
                            <td class="groupHeaderLabelCell_ar">
                                <strong style="text-decoration: underline;">رقم الزيارة : </strong>
                            </td>
                            <td class="groupHeaderDataCell_ar">: {{orderserves[0]['visitNo']}}</td>
                        </tr>
                        <!---------------------------------------------------------------------------------->

                    </tbody>
                </table>
                <p>~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~</p>
                <div>
                    <table class="full-width">
                        <thead>
                            <tr>
                                <th class="groupHeaderLevel1_ar">{{'SERVICENAME' | translate}}</th>
                                <th class="groupHeaderLevel1_ar">{{'CONDTIONS' | translate}}</th>
                                <th class="groupHeaderLevel1_ar">{{'NOTES' | translate}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let order of orderserves ;let i = index">
                                <td class="detailBand_ar reportTitle_ar">
                                    <u style="text-decoration: underline; color:blue;">-{{translate.currentLang == 'ar'
                                        ? order.serviceNameAr:order.serviceNameEn}}</u>
                                </td>

                                <td class="detailBand_ar ">
                                    <ul *ngFor="let sheet of servesConditions">
                                        <li *ngIf="order.serviceCode == sheet.serviceCode">
                                            <small>{{sheet.conditionNameAr}}</small>
                                        </li>
                                    </ul>

                                </td>
                                <td class="detailBand_ar reportTitle_ar">
                                    <u style="text-decoration: underline; ">{{order.notes}}</u>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div *ngIf="this.selectedOrder.orderPrintFlag==1">
                <div>
                    <table class="full-width">
                        <tbody>
                            <tr>
                                <td class="groupHeaderLabelCell_ar">
                                    <strong style="text-decoration: underline;">إسم المريض</strong>
                                </td>
                                <td class="groupHeaderDataCell_ar">{{orderserves[0]['patientFullnameAr']}}</td>
                                <td class="groupHeaderLabelCell_ar">
                                    <strong style="text-decoration: underline;">العمر : </strong>
                                </td>
                                <td class="groupHeaderDataCell_ar">{{orderserves[0]['patientAge']}}</td>
                            </tr>
                            <!---------------------------------------------------------------------------------->
                            <tr>
                                <td class="groupHeaderLabelCell_ar">
                                    <strong style="text-decoration: underline;">الرقم الطبى :</strong>
                                </td>
                                <td class="groupHeaderDataCell_ar">{{orderserves[0]['patCode']}}</td>
                                <td class="groupHeaderLabelCell_ar">
                                    <strong style="text-decoration: underline;">الطبيب :</strong>
                                </td>
                                <td class="groupHeaderDataCell_ar">{{orderserves[0]['doctorNameAr']}}</td>
                            </tr>
                            <!---------------------------------------------------------------------------------->
                            <tr>
                                <td class="groupHeaderLabelCell_ar">
                                    <strong style="text-decoration: underline;">رقم الطلب :</strong>
                                </td>
                                <td class="groupHeaderDataCell_ar">{{orderserves[0]['orderMasterSerial']}}</td>

                                <td class="groupHeaderLabelCell_ar">
                                    <strong style="text-decoration: underline;">تاريخ الطلب :</strong>
                                </td>
                                <td class="groupHeaderDataCell_ar">{{orderserves[0]['orderMasterDate'] |
                                    date:'dd/MM/yyyy'}}
                                </td>
                            </tr>

                            <!---------------------------------------------------------------------------------->
                            <tr>
                                <td class="groupHeaderLabelCell_ar">
                                    <strong style="text-decoration: underline;">رقم الزيارة : </strong>
                                </td>
                                <td class="groupHeaderDataCell_ar">: {{orderserves[0]['visitNo']}}</td>
                            </tr>
                            <!---------------------------------------------------------------------------------->

                        </tbody>
                    </table>
                    <p>~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~</p>
                    <div>
                        <table class="full-width">
                            <thead>
                                <tr>
                                    <th class="groupHeaderLevel1_ar">{{'SERVICENAME' | translate}}</th>
                                    <th class="groupHeaderLevel1_ar">{{'INVESTIGATIONREASON' | translate}}</th>
                                    <th class="groupHeaderLevel1_ar">{{'NOTES' | translate}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let order of orderserves ;let i = index">
                                    <td class="detailBand_ar reportTitle_ar">
                                        <u style="text-decoration: underline; color:blue;">-{{translate.currentLang ==
                                            'ar'
                                            ?
                                            order.serviceNameAr:order.serviceNameEn}}</u>
                                    </td>

                                    <td class="detailBand_ar ">
                                        <ul>
                                            {{order.investigationReason}}
                                        </ul>

                                    </td>
                                    <td class="detailBand_ar reportTitle_ar">
                                        <u style="text-decoration: underline; ">{{order.notes}}</u>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="row">
                        <table class="full-width">
                            <tbody>
                                <tr>
                                    <td class="groupHeaderLabelCell_ar">
                                        <strong style="text-decoration: underline;"> توقيع طالب الخدمة </strong>
                                    </td>
                                    <td class="groupHeaderLabelCell_ar">
                                        <strong style="text-decoration: underline;"> توقبع الطبيب </strong>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
                <div style=" margin-top: 5%;">
                    <table class="full-width">
                        <tbody>
                            <tr>
                                <td class="groupHeaderLabelCell_ar">
                                    <strong style="text-decoration: underline;">إسم المريض</strong>
                                </td>
                                <td class="groupHeaderDataCell_ar">{{orderserves[0]['patientFullnameAr']}}</td>
                                <td class="groupHeaderLabelCell_ar">
                                    <strong style="text-decoration: underline;">العمر : </strong>
                                </td>
                                <td class="groupHeaderDataCell_ar">{{orderserves[0]['patientAge']}}</td>
                            </tr>
                            <!---------------------------------------------------------------------------------->
                            <tr>
                                <td class="groupHeaderLabelCell_ar">
                                    <strong style="text-decoration: underline;">الرقم الطبى :</strong>
                                </td>
                                <td class="groupHeaderDataCell_ar">{{orderserves[0]['patCode']}}</td>
                                <td class="groupHeaderLabelCell_ar">
                                    <strong style="text-decoration: underline;">الطبيب :</strong>
                                </td>
                                <td class="groupHeaderDataCell_ar">{{orderserves[0]['doctorNameAr']}}</td>
                            </tr>
                            <!---------------------------------------------------------------------------------->
                            <tr>
                                <td class="groupHeaderLabelCell_ar">
                                    <strong style="text-decoration: underline;">رقم الطلب :</strong>
                                </td>
                                <td class="groupHeaderDataCell_ar">{{orderserves[0]['orderMasterSerial']}}</td>

                                <td class="groupHeaderLabelCell_ar">
                                    <strong style="text-decoration: underline;">تاريخ الطلب :</strong>
                                </td>
                                <td class="groupHeaderDataCell_ar">{{orderserves[0]['orderMasterDate'] |
                                    date:'dd/MM/yyyy'}}
                                </td>
                            </tr>

                            <!---------------------------------------------------------------------------------->
                            <tr>
                                <td class="groupHeaderLabelCell_ar">
                                    <strong style="text-decoration: underline;">رقم الزيارة : </strong>
                                </td>
                                <td class="groupHeaderDataCell_ar">: {{orderserves[0]['visitNo']}}</td>
                            </tr>
                            <!---------------------------------------------------------------------------------->

                        </tbody>
                    </table>
                    <p>~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~</p>
                    <div>
                        <table class="full-width">
                            <thead>
                                <tr>
                                    <th class="groupHeaderLevel1_ar">{{'SERVICENAME' | translate}}</th>
                                    <th class="groupHeaderLevel1_ar">{{'INVESTIGATIONREASON' | translate}}</th>
                                    <th class="groupHeaderLevel1_ar">{{'NOTES' | translate}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let order of orderserves ;let i = index">
                                    <td class="detailBand_ar reportTitle_ar">
                                        <u style="text-decoration: underline; color:blue;">-{{translate.currentLang ==
                                            'ar'
                                            ?
                                            order.serviceNameAr:order.serviceNameEn}}</u>
                                    </td>

                                    <td class="detailBand_ar ">
                                        <ul>
                                            {{order.investigationReason}}
                                        </ul>

                                    </td>
                                    <td class="detailBand_ar reportTitle_ar">
                                        <u style="text-decoration: underline; ">{{order.notes}}</u>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="row">
                        <table class="full-width">
                            <tbody>
                                <tr>
                                    <td class="groupHeaderLabelCell_ar">
                                        <strong style="text-decoration: underline;"> توقيع طالب الخدمة </strong>
                                    </td>
                                    <td class="groupHeaderLabelCell_ar">
                                        <strong style="text-decoration: underline;"> توقبع الطبيب </strong>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
                <div style=" margin-top: 5%;">
                    <table class="full-width">
                        <tbody>
                            <tr>
                                <td class="groupHeaderLabelCell_ar">
                                    <strong style="text-decoration: underline;">إسم المريض</strong>
                                </td>
                                <td class="groupHeaderDataCell_ar">{{orderserves[0]['patientFullnameAr']}}</td>
                                <td class="groupHeaderLabelCell_ar">
                                    <strong style="text-decoration: underline;">العمر : </strong>
                                </td>
                                <td class="groupHeaderDataCell_ar">{{orderserves[0]['patientAge']}}</td>
                            </tr>
                            <!---------------------------------------------------------------------------------->
                            <tr>
                                <td class="groupHeaderLabelCell_ar">
                                    <strong style="text-decoration: underline;">الرقم الطبى :</strong>
                                </td>
                                <td class="groupHeaderDataCell_ar">{{orderserves[0]['patCode']}}</td>
                                <td class="groupHeaderLabelCell_ar">
                                    <strong style="text-decoration: underline;">الطبيب :</strong>
                                </td>
                                <td class="groupHeaderDataCell_ar">{{orderserves[0]['doctorNameAr']}}</td>
                            </tr>
                            <!---------------------------------------------------------------------------------->
                            <tr>
                                <td class="groupHeaderLabelCell_ar">
                                    <strong style="text-decoration: underline;">رقم الطلب :</strong>
                                </td>
                                <td class="groupHeaderDataCell_ar">{{orderserves[0]['orderMasterSerial']}}</td>

                                <td class="groupHeaderLabelCell_ar">
                                    <strong style="text-decoration: underline;">تاريخ الطلب :</strong>
                                </td>
                                <td class="groupHeaderDataCell_ar">{{orderserves[0]['orderMasterDate'] |
                                    date:'dd/MM/yyyy'}}
                                </td>
                            </tr>

                            <!---------------------------------------------------------------------------------->
                            <tr>
                                <td class="groupHeaderLabelCell_ar">
                                    <strong style="text-decoration: underline;">رقم الزيارة : </strong>
                                </td>
                                <td class="groupHeaderDataCell_ar">: {{orderserves[0]['visitNo']}}</td>
                            </tr>
                            <!---------------------------------------------------------------------------------->

                        </tbody>
                    </table>
                    <p>~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~</p>
                    <div>
                        <table class="full-width">
                            <thead>
                                <tr>
                                    <th class="groupHeaderLevel1_ar">{{'SERVICENAME' | translate}}</th>
                                    <th class="groupHeaderLevel1_ar">{{'INVESTIGATIONREASON' | translate}}</th>
                                    <th class="groupHeaderLevel1_ar">{{'NOTES' | translate}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let order of orderserves ;let i = index">
                                    <td class="detailBand_ar reportTitle_ar">
                                        <u style="text-decoration: underline; color:blue;">-{{translate.currentLang ==
                                            'ar'
                                            ?
                                            order.serviceNameAr:order.serviceNameEn}}</u>
                                    </td>

                                    <td class="detailBand_ar ">
                                        <ul>
                                            {{order.investigationReason}}
                                        </ul>

                                    </td>
                                    <td class="detailBand_ar reportTitle_ar">
                                        <u style="text-decoration: underline; ">{{order.notes}}</u>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="row">
                        <table class="full-width">
                            <tbody>
                                <tr>
                                    <td class="groupHeaderLabelCell_ar">
                                        <strong style="text-decoration: underline;"> توقيع طالب الخدمة </strong>
                                    </td>
                                    <td class="groupHeaderLabelCell_ar">
                                        <strong style="text-decoration: underline;"> توقبع الطبيب </strong>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>


            <!-- <div class="wrapper">
                    <div >
                        <table style=" width: 100%" >
                            <thead>
                                <tr>
                                    <th colspan="2" class="groupHeaderLevel1_ar">
                                        <u style="text-decoration: underline; color:blue;">-{{translate.currentLang == 'ar' ? order.serviceNameAr:order.serviceNameEn}}</u>
                                    </th>
                                </tr>
                            </thead>
    
                            <tbody>
                                
                                <ng-template ngFor let-sheet [ngForOf]="servesConditions">
                                    <tr *ngIf="order.serviceCode == sheet.serviceCode">
                                        <td class="">- {{sheet.conditionNameAr}}</td>
                                    </tr>
    
                                </ng-template>
                            </tbody>
    
                        </table>
    
    
                    </div>
                </div> -->
        </div>
        <div class="wrapper" *ngIf="masterSerial">
            <table class="full-width">
                <tr style="vertical-align:top;">
                    <td colspan="6" class="reportTitle_ar custom-head-color">{{ 'MEDICALFILE' | translate }}</td>
                </tr>
                <tr style="vertical-align:top;">
                    <td colspan="6" class="tr-as-line"></td>
                </tr>
            </table>
            <div class="main_tables">
                <table class="full-width" width="100%">
                    <caption>جدول الجلسات</caption>
                    <tr style="text-align: center;">
                        <th class="groupHeaderLevel1_ar">رقم الجلسة</th>
                        <th class="groupHeaderLevel1_ar">اليوم</th>
                        <th class="groupHeaderLevel1_ar">الساعة</th>
                        <th class="groupHeaderLevel1_ar">توقيت الجلسة</th>
                        <th class="groupHeaderLevel1_ar">عدد الأجهزة</th>
                        <th class="groupHeaderLevel1_ar">امضاء التمريض</th>
                    </tr>
                    <tr style="text-align: center;" *ngFor="let order of orderPrintData;let i = index">
                        <td class="detailBand_ar">
                            {{i+1}}
                        </td>
                        <td class="detailBand_ar">
                            {{order.expectedStartTime | date:'fullDate' }}
                        </td>
                        <td class="detailBand_ar">
                            {{order.expectedStartTime | date:'shortTime' }}
                        </td>
                        <td class="detailBand_ar">
                            {{order.timeSlot}} دقيقة
                        </td>
                        <td class="detailBand_ar">
                            {{order.serviceNameAr}} .. {{order.bodyPartAr}}
                        </td>
                        <td class="detailBand_ar">
                            {{'............'}}
                        </td>
                    </tr>
                </table>
            </div>
        </div>

        <div class="footer" *ngIf="this.selectedOrder.orderPrintFlag!=1">
            <table class="full-width">
                <tr>
                    <td class="groupHeaderDataCell_ar">
                        <strong>Phone:</strong>01022833775
                    </td>
                    <td class="groupHeaderDataCell_ar">
                        <strong>Email:</strong>
                        <a href="web@bee.com">web&#64;BEE.com</a>
                    </td>
                </tr>
            </table>
        </div>

    </div>
</div>
<app-print-page #printComponent section="orderPrint" [autoPrint]="autoPrint"></app-print-page>